import {
  DEFAULT_LOCALE,
  getEffectiveLocaleValue,
  getLocaleOption,
  type LocaleValue,
} from '@app/constants/locale-options';
import { LOCALIZATION_SETTINGS } from '@app/constants/permissions';
import { ADMIN_QUERY_KEYS, QUERY_KEYS } from '@app/constants/service';
import type { ReadableQueryClient } from '@app/query-client';
import type { FullOrganizationData } from '@app/services/admin';
import type { UserProperties } from '@app/services/user-properties';
import { StateType } from '@app/types/reducer-state';

export const resolveOperatorSendLanguage = (
  hasLocalizationSettingsAccess: boolean,
  userProperties?: UserProperties,
  fullOrgData?: FullOrganizationData,
): LocaleValue | undefined => {
  if (!hasLocalizationSettingsAccess) return DEFAULT_LOCALE;
  if (!userProperties) return undefined;
  const userLocale = getLocaleOption(userProperties.language ?? '')?.value;
  if (userLocale) return userLocale;
  if (!fullOrgData) return undefined;
  return getEffectiveLocaleValue(
    fullOrgData.organizationSettings?.language,
    DEFAULT_LOCALE,
  );
};

export const isTranslatingForCase = (
  caseLanguage: string | null | undefined,
  sendLanguage: string | undefined,
) =>
  sendLanguage !== undefined &&
  (caseLanguage || DEFAULT_LOCALE).toLowerCase() !== sendLanguage.toLowerCase();

export const getOperatorSendLanguageFromCache = (
  queryClient: ReadableQueryClient | null | undefined,
  state: StateType,
): LocaleValue | undefined =>
  resolveOperatorSendLanguage(
    (state?.auth?.permissions ?? []).includes(LOCALIZATION_SETTINGS),
    queryClient?.getQueryData?.(
      QUERY_KEYS.USER_PROPERTIES(state?.auth?.user?._id ?? ''),
    ) as UserProperties | undefined,
    queryClient?.getQueryData?.(
      ADMIN_QUERY_KEYS.fullOrgData(state?.organizations?._id ?? ''),
    ) as FullOrganizationData | undefined,
  );
